import { api } from '../api/client'
import type { Summary } from './format'

export type MonthCell = { period: string; status: string; built_at: string | null; balanced: boolean | null }
export type TitleRow = { slug: string; name: string; books: 'aamcirc'; takeover: string; months: MonthCell[] }
export type Exceptions = {
  no_months: Record<string, unknown>[]
  unmatched_refunds: Record<string, unknown>[]
  late: Record<string, unknown>[]
  access_mismatches: Record<string, unknown>[]
  access_mismatch_total: number
  lines_without_title: Record<string, unknown>[]
}
export type Close = {
  slug: string; name: string; period: string; books: string; takeover: string | null; status: string; summary: Summary
  changes: { key: string; before: unknown; after: unknown }[]; exceptions: Exceptions
  built_at: string | null; approved_at: string | null; approved_by: string | null
  reopened_reason: string | null; opening_signoff: Record<string, string> | null
}
export type HistoryMonth = {
  month: string; issue: string | null; issue_date: string | null; as_of: string | null
  gross_earned: string | null; net_earned: string | null; commission_earned: string | null
  gross_deferred: string | null; net_deferred: string | null; copies_deferred: number | null
  cash_total: string | null; cash_tax: string | null; cash_payments: number | null
}
export type HistoryTitle = { slug: string; name: string; takeover: string | null; months: HistoryMonth[] }
export type AccountsResponse = { keys: string[]; scopes: string[]; rows: { scope: string; key: string; account_name: string }[] }

const base = '/api/accounting'
export const accountingApi = {
  closes: () => api.get<{ titles: TitleRow[] }>(`${base}/closes`),
  close: (slug: string, period: string) => api.get<Close>(`${base}/closes/${slug}/${period}`),
  rebuild: (slug: string, period: string) => api.post(`${base}/closes/${slug}/${period}/rebuild`),
  approve: (slug: string, period: string) => api.post(`${base}/closes/${slug}/${period}/approve`),
  reopen: (slug: string, period: string, reason: string) => api.post(`${base}/closes/${slug}/${period}/reopen`, { reason }),
  signOff: (slug: string, period: string, note: string) => api.post(`${base}/closes/${slug}/${period}/opening-signoff`, { note }),
  report: <T,>(slug: string, period: string, name: string) => api.get<T>(`${base}/reports/${slug}/${period}/${name}?format=json`),
  history: () => api.get<{ titles: HistoryTitle[] }>(`${base}/history`),
  historyCsvUrl: (slug: string) => `${base}/history/${slug}.csv`,
  historyCashUrl: (slug: string, period: string) => `${base}/history/${slug}/${period}/cash.csv`,
  accounts: () => api.get<AccountsResponse>(`${base}/accounts`),
  putAccount: (scope: string, key: string, account_name: string) => api.put(`${base}/accounts`, { scope, key, account_name }),
  fileUrl: (slug: string, period: string, name: string, format: 'csv' | 'xlsx') => `${base}/reports/${slug}/${period}/${name}?format=${format}`,
  workbookUrl: (slug: string, period: string) => `${base}/workbook/${slug}/${period}.xlsx`,
  journalUrl: (slug: string, period: string) => `${base}/journal/${slug}/${period}.csv`,
}
